import { SIMPLMenuHeader } from "../../components/commons/header/SIMPLMenuHeader";
import { SIMPLTable } from "../../components/commons/table/SimplTable";
import { Layout } from "../../components/commons/layout/Layout";
import { ChangeEvent, useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { SIMPLButtonCustomized } from "../../components/commons/button/SIMPLButtonCustumized";
import { SIMPLAlert } from "../../components/commons/dialog/SimplAlert";
import { toast } from "react-toastify";
import useSessionTimeout from "~/services/session/SessionTimeOut";
import { LoadingWrapper } from "../../components/commons/spiner/SimpleLoaderWrapper";
import { LABELS } from "~/resources/Labels";
import {
  attachResourcesToCloudEnviroments,
  displayEntries,
  sortScripts,
} from "~/Utils/Utils";
import { useAppDispatch } from "~/hooks/appSelector";
import { useLocation, useNavigate } from "react-router-dom";
import { FormCloudEnvironment, FormCloudEnvironmentResponse, PropRow, SortTable } from "~/models/Commons ";
import { handleDeleteEntity } from "~/Utils/helpers/DeleteEntityHelper";
import { Alerts } from "../messages/Alerts";

type CloudEntityProps = {
  title: string;
  addLabel: string;
  tableHeaders: any;
  fetchHook: (params: any) => {
    data?: any;
    refetch: () => void;
    isLoading: boolean;
    isError: boolean;
  };
  deleteHook: () => any;
  navigateAddRoute: string;
  navigateEditRoute?: string; // route for edit page
  detailViewComponent: React.FC<{
    item: FormCloudEnvironmentResponse;
    onClose: () => void;
  }>;
  showButtonMoreActions?:boolean
  showButtonDecommissionInModal?:boolean
  showButtonDownloadInModal?:boolean
  showConfigFileInModal?:boolean
  showButtonDeleteInModal?:boolean
  showButtonDetailsInModal?:boolean
  showEditInModal?:boolean
  isActive?:boolean
  setIsActive?:React.Dispatch<React.SetStateAction<boolean>>
  activeLabel?:string;
  inactiveLabel?:string;
  tabs?:boolean
};

export const SIMPLCloudEntity = ({
  title,
  addLabel,
  tableHeaders,
  fetchHook,
  deleteHook,
  navigateAddRoute,
  navigateEditRoute,
  detailViewComponent: DetailView,
  showButtonMoreActions,
  showButtonDecommissionInModal,
  showButtonDownloadInModal,
  showConfigFileInModal,
  showButtonDeleteInModal,
  showButtonDetailsInModal,
  showEditInModal,
  isActive = true,
  setIsActive,
  tabs = false,
  activeLabel = 'Active',
  inactiveLabel = 'Inactive'
}: CloudEntityProps) => {
  const navigate = useNavigate();
  const [deleteEntity] = deleteHook();
  const location = useLocation();
const { success,response,error} = location?.state || {};
  const [showFilter, setShowFilter] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [rows, setRows] = useState<PropRow[]>([]);
  const [size, setSize] = useState(5);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [showPagination, setShowPagination] = useState(true);
  const [openDetailView, setOpenDetailView] = useState(false);
  const [item, setItem] = useState({} as FormCloudEnvironment);
  const [editItem, setEditItem] = useState({} as FormCloudEnvironmentResponse);
  const [deleteModal, setDeleteModal] = useState(false);
   const [cloudEnvSuccess, setCloudEnvSuccess] = useState(false);
  const [cloudEnvError, setCloudEnvError] = useState(false);

  type ResponseDetails = {
    title: string;
    message: string;
  };
  const [cloudEnvDetails, setCloudEnvDetails] =
    useState<ResponseDetails | null>(null);
  const [sortConfig, setSortConfig] = useState<SortTable>({
    key: "",
    direction: LABELS.ASC,
  });

  const INACTIVITY_LIMIT = Number(import.meta.env.VITE_INACTIVITY_LIMIT);
  const FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN = Number(
    import.meta.env.VITE_FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN,
  );

  const { data, refetch, isLoading, isError } = fetchHook({
    page: 0,
    size: 999,
    active:isActive,
  });

  // Session timeout
  useSessionTimeout({
    inactivityLimit: INACTIVITY_LIMIT,
    forcedLogoutLimit: FORCED_LOGOUT_LIMIT_EXPIRED_TOKEN,
    storage: sessionStorage,
  });

  // Sort handler
  const handleSort = (key: string) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === LABELS.ASC
        ? LABELS.Desc
        : LABELS.ASC;
    setSortConfig({ key, direction });
  };

  // Initialize table rows
  const initRows = () => {
    const payload = data?.payload;
    if (!payload || payload.length === 0) {
      setShowPagination(false);
      return;
    }
    const merged = attachResourcesToCloudEnviroments(payload);
    const sorted = sortScripts(merged, sortConfig);
    const mapped = displayEntries(sorted, totalElements, 999);
    setTotal(payload.page?.totalPages || 0);
    setTotalElements(payload.page?.totalElements || 0);
    setRows(mapped.map((row: any) => ({ row })));
    setShowPagination(true);
  };

  useEffect(() => initRows(), [data, sortConfig, size, total, totalElements]);

  const handleVmTemplateResponse = () => {
  if (success) {
    setCloudEnvDetails({
      title: "Operation completed successfully",
      message: response?.message,
    });

    setCloudEnvSuccess(true);
    setCloudEnvError(false);
  } else  {
    setCloudEnvDetails({
    title: `${error?.data?.title} (${error?.data?.status})` ,
     message: error?.data?.detail,
    });

    setCloudEnvSuccess(false);
    setCloudEnvError(true);
  }
};
useEffect(() => {
  if (location.state) {
    handleVmTemplateResponse();
    navigate(location.pathname, { replace: true, state: null });
  }
}, [location.state]);
  // Delete logic
  const handleConfirmDelete = (entity: FormCloudEnvironment) => {
    if (entity.id) {
      setItem(entity);
      setDeleteModal(true);
    }
  };

const handleDeleteItem = async () => {
  handleDeleteEntity({
      deleteFn: () => deleteEntity(item.id).unwrap(),
      id: item.id!,
      refetchFn: refetch,
      onBeforeDelete: () => setDeleteModal(false),
      onSuccess: (title, message) => {
        setCloudEnvError(false);
        setCloudEnvSuccess(true);
        setCloudEnvDetails({ title, message });
      },
      onError: (title, message) => {
        setCloudEnvSuccess(false);
        setCloudEnvError(true);
        setCloudEnvDetails({ title, message });
      },
    });
};


  // Add/Edit/Detail handlers
  const handleAddEntity = () => navigate(navigateAddRoute);

  const handleEdit = (entity: FormCloudEnvironment) => {
    if (!entity.id) return console.warn(`${title} ID does not exist`);
    setItem(entity);
    if (navigateEditRoute) {
      navigate(navigateEditRoute, { state: { editedItem: entity } });
    } 
  };

  const handleOpenDetail = (entity: FormCloudEnvironmentResponse) => {
    if (!entity.id) return console.warn(`${title} ID does not exist`);
    setEditItem(entity);
    setOpenDetailView(true);
  };
 const renderCloudEnvAlerts = () => (
    <Alerts
      showSuccess={cloudEnvSuccess}
      showError={cloudEnvError}
      title={cloudEnvDetails?.title}
      successMessage={cloudEnvDetails?.message || ""}
      errorMessage={cloudEnvDetails?.message || ""}
      onCloseSucessDialog={() => setCloudEnvSuccess(false)}
      onCloseErrorDialog={() => setCloudEnvError(false)}
      enabledSuccess={cloudEnvSuccess}
      enabledError={cloudEnvError }
    />
  );
  return (
    <SIMPLMenuHeader>
      {renderCloudEnvAlerts()}
      <Layout>
        {/* Detail modal */}
        {openDetailView && (
          <DetailView
            item={editItem}
            onClose={() => setOpenDetailView(false)}
          />
        )}

        {/* Delete modal */}
        {deleteModal && (
          <SIMPLAlert
            onCancel={() => setDeleteModal(false)}
            title={`Delete ${title}`}
            message={`Are you sure you want to delete ${item.environmentName}?`}
            actions={
              <>
                <SIMPLButtonCustomized
                  label="Cancel"
                  secondary
                  buttonHandlerAction={() => setDeleteModal(false)}
                />
                <SIMPLButtonCustomized
                  label="Delete Item"
                  danger
                  buttonHandlerAction={handleDeleteItem}
                />
              </>
            }
          />
        )}

        {/* Add/Decommission modal */}
        {isAddModalOpen && (
          <SIMPLAlert
            onCancel={() => setIsAddModalOpen(false)}
            title={LABELS.TitleDecommission}
            message="Decommission message"
            actions={
              <SIMPLButtonCustomized
                label="Close"
                secondary
                buttonHandlerAction={() => setIsAddModalOpen(false)}
              />
            }
          />
        )}

        <LoadingWrapper
          isLoading={isLoading}
          isError={isError}
          loadingTitle={`Loading ${title}...`}
        >
          <SIMPLTable
            title={title}
            rows={rows}
            tableHeaders={tableHeaders}
            page={page}
            size={size}
            showPagination={showPagination}
            showHandler={() => setShowFilter((prev) => !prev)}
            filterActive={showFilter}
            handleDelete={handleConfirmDelete}
            handleOpenEdit={handleEdit}
            handleOpenDetail={handleOpenDetail}
            handleSort={handleSort}
            sortConfig={sortConfig}
            onChangePage={setPage}
            lastBorder="border-l border-white"
            activeLabel={activeLabel}
            inactiveLabel={inactiveLabel} 
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              setSize(Number(e.target.value))
            }
            clear={() => {
              setPage(0);
              setShowFilter(false);
            }}
            button={
              <SIMPLButtonCustomized
                label={addLabel}
                primary
                buttonHandlerAction={handleAddEntity}
                secondIcon={<AddIcon />}
              />
            }
            showButtonMoreActions={showButtonMoreActions}
            showButtonDecommissionInModal={showButtonDecommissionInModal}
            showButtonDownloadInModal={showButtonDownloadInModal}
            showConfigFileInModal={showConfigFileInModal}
             showButtonDeleteInModal={showButtonDeleteInModal}
            showButtonDetailsInModal={showButtonDetailsInModal}
            showEditInModal={showEditInModal}
            showCopyInModal={false}
            active={true}
             setIsActive={setIsActive}
            isActive={isActive}
            tabs={tabs}
          />
        </LoadingWrapper>
      </Layout>
    </SIMPLMenuHeader>
  );
};
